<template>
  <div class="quick-action">
    <button type="button" class="button" @click.stop.prevent="openDeskingLink()" v-tooltip="'Click to view desk deal.'">
      <b-icon pack="fal" icon="edit" custom-size="fa-lg"></b-icon>
    </button>
  </div>
</template>

<script>

import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'

const mapDealerGetters = createNamespacedHelpers('dealer').mapGetters
const mapSubscriberGetters = createNamespacedHelpers('subscriber').mapGetters
const DEFAULT_DEALER_PEAK_HOME_URL = 'https://eagfortlauderdale.dealerpeak.net'

export default {
  name: 'InventoryDeskDeal',
  mixins: [],
  components: {
  },
  props: {
    crmInventoryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapDealerGetters({ currentDealer: 'getCurrentDealer' }),
    ...mapSubscriberGetters({ currentSubscriber: 'getCurrentSubscriber' }),
    resolvedDealerPeakHomeUrl () {
      const sanitize = (value) => {
        if (!value || typeof value !== 'string') {
          return ''
        }

        let trimmed = value.trim()
        while (trimmed.endsWith('/')) {
          trimmed = trimmed.slice(0, -1)
        }
        return trimmed
      }

      const dealerUrl = sanitize((this.currentDealer || {}).dealerPeakHomeUrl)
      if (dealerUrl) {
        return dealerUrl
      }

      const subscriberUrl = sanitize((this.currentSubscriber || {}).dealerPeakHomeUrl)
      if (subscriberUrl) {
        return subscriberUrl
      }

      return DEFAULT_DEALER_PEAK_HOME_URL
    }
  },
  methods: {
    openDeskingLink: function () {
      const baseUrlWithoutTrailingSlash = this.resolvedDealerPeakHomeUrl
      if (!baseUrlWithoutTrailingSlash) {
        return
      }

      const baseUrl = baseUrlWithoutTrailingSlash.endsWith('/') ? baseUrlWithoutTrailingSlash : `${baseUrlWithoutTrailingSlash}/`
      const timestamp = moment().valueOf()

      const url = `${baseUrl}?fuseaction=Desk.DealScreen&LeadID=&CarID=${this.crmInventoryId}&Layout=Popup&ts=${timestamp}`
      const windowOptions = 'width=500,height=400,resizable=yes'
      window.open(url, '_blank', windowOptions)
    }
  },
  watch: {

  },
  mounted: function () {

  }
}

</script>

<style scoped>
  .desk-deal {
    padding:0px 10px 0px 5px;
    cursor:pointer;
  }
</style>



